import { Api } from '../api';
import { statements } from '../endpoints';
import type { GetStatementsResponse } from './models';

export class StatementsApi extends Api {
  static getStatements = (id: number) => this.get<GetStatementsResponse[]>({ url: statements.getStatements(id) });

  static downloadStatement = (accountId: string, year: string, month: string) =>
    this.get<Blob>({ url: statements.downloadStatement(accountId, year, month) });
}
